'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchPickupStationsIfNeeded = exports.failurePickupStations = exports.receivePickupStations = exports.requestPickupStations = exports.invalidatePickupStations = exports.filterPickupStations = exports.INVALIDATE_PICKUP_STATIONS = exports.FILTER_PICKUP_STATIONS = exports.FAILURE_PICKUP_STATIONS = exports.RECEIVE_PICKUP_STATIONS = exports.REQUEST_PICKUP_STATIONS = undefined;

var _api = require('../api');

var REQUEST_PICKUP_STATIONS = exports.REQUEST_PICKUP_STATIONS = 'REQUEST_PICKUP_STATIONS'; /**
                                                                                            * 自提点相关Actions
                                                                                            */
var RECEIVE_PICKUP_STATIONS = exports.RECEIVE_PICKUP_STATIONS = 'RECEIVE_PICKUP_STATIONS';
var FAILURE_PICKUP_STATIONS = exports.FAILURE_PICKUP_STATIONS = 'FAILURE_PICKUP_STATIONS';
var FILTER_PICKUP_STATIONS = exports.FILTER_PICKUP_STATIONS = 'FILTER_PICKUP_STATIONS';
var INVALIDATE_PICKUP_STATIONS = exports.INVALIDATE_PICKUP_STATIONS = 'INVALIDATE_PICKUP_STATIONS';

var filterPickupStations = exports.filterPickupStations = function filterPickupStations(filter) {
    return {
        type: FILTER_PICKUP_STATIONS,
        filter: filter
    };
};

var invalidatePickupStations = exports.invalidatePickupStations = function invalidatePickupStations(filter) {
    return {
        type: INVALIDATE_PICKUP_STATIONS,
        filter: filter
    };
};

var requestPickupStations = exports.requestPickupStations = function requestPickupStations(filter) {
    return {
        type: REQUEST_PICKUP_STATIONS,
        filter: filter
    };
};

var receivePickupStations = exports.receivePickupStations = function receivePickupStations(filter, json) {
    return {
        type: RECEIVE_PICKUP_STATIONS,
        filter: filter,
        pickupStations: json,
        received_at: Date.now()
    };
};
var failurePickupStations = exports.failurePickupStations = function failurePickupStations(error) {
    return {
        type: FAILURE_PICKUP_STATIONS,
        error: error
    };
};

var shouldFetchPickupStations = function shouldFetchPickupStations(state, filter) {
    var pickupStations = state.pickupStation.pickupStations;
    if (pickupStations.items.length === 0) {
        return true;
    }
    if (pickupStations.isFetching) {
        return false;
    }
    return true;
};

var fetchPickupStationsIfNeeded = exports.fetchPickupStationsIfNeeded = function fetchPickupStationsIfNeeded(filter) {
    return function (dispatch, getState) {
        if (shouldFetchPickupStations(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestPickupStations(filter));
                return (0, _api.fetchPickupStations)(filter).then(function (response) {

                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receivePickupStations(filter, json));
                }).catch(function (error) {
                    return dispatch(failurePickupStations(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/pickup_station.js
// module id = 898
// module chunks = 0